const selectors = {
  video: "video-component",
};
export default selectors;
